<template>
    <div class="event">
      <div class="pay">
        <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
        <form class="app-pay-form" @submit.prevent="send">
            <br>
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Ödemeyi Başlat'" />
        </form>
      </div>
    </div>
  </template>
  
  <script>
    import Header from '../../../../components/User/Pay/Header'
    import Form from '../../../../components/User/Pay/Form'
  
    export default{
      props:['providerInfo', 'provider'],
      data(){
        return{
          btnLoading: false,
        }
      },
      created(){
      },
      computed: 
      {
      },
      methods:{
        send() {
          this.btnLoading = true;
          axios.post('/user/wallet/deposit/' + this.provider + '/create')
          .then((response) => {
              if (response.data.status) 
              {
                  location.href = response.data.url;
              }
          })
          .catch((err) => {
          })
          .finally(() => {
            this.btnLoading = false;
          });
        },
      },
      components:{
        Header,
        Form
      }
    }
  
  </script>